<template>
  <div class="video-box">
    <video loop="loop" style="margin: 10px 20px 10px 0" v-if="videoSrcArr.length>0" v-for="(item,index) in videoSrcArr" :width="width"
           :height="height" controls>
      <source :src="item" type="video/mp4">
    </video>
  </div>

</template>
<script>
import { getAction } from '@/api/manage'

export default {
  props: ['siteId'],
  data() {
    return {
      videoSrcArr: [],
      width: 0,
      height: 0
    }
  },
  mounted() {
    this.width = document.querySelector('.video-box').clientWidth * 0.47
    this.height = document.querySelector('.video-box').clientWidth * 0.25
    window.addEventListener('resize',this.getResize)
    // this.getVideoList()
  },
  beforeDestroy() {
    window.removeEventListener('resize',this.getResize)
  },
  // watch: {
  //   siteId(value) {
  //     this.getVideoList()
  //   }
  // },
  methods: {
    getResize() {
      this.width = document.querySelector('.video-box').clientWidth * 0.47
      this.height = document.querySelector('.video-box').clientWidth * 0.25
    },
    getVideoList() {
      this.videoSrcArr = []
      getAction('site/info/devops/getBySite', { siteId: this.siteId }).then(res => {
        if (res.success) {
          getAction(`sys/common/file/queryFile/site_info_devops/${res.result.id}`).then(res => {
            if (res.success) {
              res.result.forEach(item => {
                this.videoSrcArr.push(window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id)
              })
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.video-box {
  width: 100%;
  height: 700px;
  overflow-y: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>